import React, { useEffect, useState } from "react";
import { PeekInputAdornment, PeekTextField, PeekTypography, useTheme } from "@piiqtechnologies/ui-components";
import { Search as SearchIcon } from "@piiqtechnologies/svg-icons";
import { useDebounce } from "@piiqtechnologies/ui-lib";
export const SearchInput = ({ placeholder, value, onChange, width = "400px" }) => {
    const theme = useTheme();
    const [inputValue, setInputValue] = useState(value);
    const debouncedValue = useDebounce(inputValue, 400);
    useEffect(() => {
        onChange(debouncedValue);
    }, [debouncedValue]);
    useEffect(() => {
        setInputValue(value);
    }, [value]);
    return (React.createElement(PeekTextField, { sx: {
            m: 0,
            width,
            backgroundColor: "common.white",
            borderRadius: theme.spacing(2),
            "& .MuiInput-root": {
                mt: 0,
                height: theme.spacing(3.8),
                minHeight: "unset !important",
                borderRadius: theme.spacing(2),
            },
            input: {
                marginRight: theme.spacing(1.6),
                "&::placeholder": {
                    opacity: 1,
                    color: theme.palette.grey[300],
                },
            },
        }, onChange: (event) => setInputValue(event.target.value), variant: "standard", value: inputValue, InputLabelProps: { required: true }, InputProps: {
            placeholder,
            disableUnderline: true,
            "aria-label": "Search",
            startAdornment: (React.createElement(PeekInputAdornment, { position: "end" },
                React.createElement(PeekTypography, { variant: "h3", color: "text", display: "flex", sx: { ml: 1 } },
                    React.createElement(SearchIcon, { color: theme.palette.grey[300] })))),
        } }));
};
export default SearchInput;
